import type { FC } from 'react';

import type { AssetsSegmentSchemaWithIdPatched } from '@iconik-io/iconik-api/src/schema_patched/assets_segments';

import { Linkify } from '../ui/linkify/linkify';

import styles from './segment_value_comment.module.css';

type Props = {
  segment: AssetsSegmentSchemaWithIdPatched;
  value: string;
};

export const SegmentValueComment: FC<Props> = (props) => {
  // Trim leading/trailing newlines and apply full width for multiline comments
  // to prevent awkward narrow-column layout where short multiline text
  // (e.g., "multi\nline\ncomment") renders as a thin vertical stack
  const trimmedValue = props.value.replace(/^\n+|\n+$/g, '');
  const isMultiline = trimmedValue.includes('\n');

  return (
    <span
      aria-label="Comment text"
      className={isMultiline ? styles.multiline : undefined}
    >
      <Linkify>{trimmedValue}</Linkify>
    </span>
  );
};
